import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { PresidioImpersonationFacade } from '../services/presidio-impersonation.facade';

import { PresidioImpersonationSelectModalComponent } from './presidio-impersonation-select-modal.component';

/**
 * DEMO MVP 8.2.2 — CSR header control that opens the searchable View-as modal.
 */
@Component({
  selector: 'prs-impersonation-picker',
  templateUrl: './presidio-impersonation-picker.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, NgIf, TranslatePipe],
})
export class PresidioImpersonationPickerComponent implements OnInit {
  private facade = inject(PresidioImpersonationFacade);
  private modal = inject(NgbModal);
  private cdr = inject(ChangeDetectorRef);

  isImpersonating$: Observable<boolean>;
  busy = false;

  ngOnInit(): void {
    this.facade.refresh();
    this.isImpersonating$ = this.facade.isImpersonating$;
  }

  openPicker(): void {
    if (this.busy) {
      return;
    }
    const ref = this.modal.open(PresidioImpersonationSelectModalComponent, {
      centered: true,
      size: 'md',
      backdrop: 'static',
      keyboard: true,
      windowClass: 'prs-modal prs-auth-modal prs-impersonation-modal-window',
      ariaLabelledBy: 'prs-csr-view-as-title',
    });
    ref.closed.subscribe(() => {
      this.busy = false;
      this.cdr.markForCheck();
    });
    ref.dismissed.subscribe(() => {
      this.busy = false;
      this.cdr.markForCheck();
    });
  }
}
